var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _WarningIcon from '@mui/icons-material/Warning';
import _InfoIcon from '@mui/icons-material/Info';
import _SuccessIcon from '@mui/icons-material/CheckCircle';
import { COLOR } from '../../../theme/colors';
import { Markdown } from '../Markdown';
import { Row } from '../layout/Row';
import { Icon } from '../Icon';
import { FONT_SIZE } from '../../../theme/typography';
import { useAlerts, ALERT_TYPE } from '../../providers/alerts';
import { useTheme } from '../../../theme';
import { BUTTON_TYPE, Button } from '../Button';
import { importedDefaultComponentShim } from '../../../utils/misc';
import { Box } from '../layout/Box';
const WarningIcon = importedDefaultComponentShim(_WarningIcon);
const InfoIcon = importedDefaultComponentShim(_InfoIcon);
const SuccessIcon = importedDefaultComponentShim(_SuccessIcon);
export const Alerts = (_a) => {
    var { pageAlerts, alertStyles } = _a, rest = __rest(_a, ["pageAlerts", "alertStyles"]);
    const { alerts, dismiss } = useAlerts(pageAlerts);
    return (_jsx(Box, Object.assign({}, rest, { children: alerts.map((alert, i) => {
            const { type, description } = alert;
            return (_jsx(Alert, { type: type, description: description, "data-nosnippet": true, sx: Object.assign({ mt: i ? '4px' : 0 }, alertStyles), dismiss: () => {
                    dismiss(alert.id);
                } }, i));
        }) })));
};
export const Alert = (_a) => {
    var _b;
    var { type = ALERT_TYPE.INFORMATIONAL, description = '', dismiss, sx } = _a, rest = __rest(_a, ["type", "description", "dismiss", "sx"]);
    const theme = useTheme();
    const style = {
        backgroundColor: COLOR.ALERT_INFORMATIONAL_BG,
        boxShadow: (_b = theme.boxShadow) === null || _b === void 0 ? void 0 : _b.NORMAL,
        border: '2px solid',
        borderColor: COLOR.ALERT_INFORMATIONAL_BORDER,
        m: 0,
        p: '1rem',
    };
    if (type === ALERT_TYPE.INFORMATIONAL_YELLOW) {
        style.backgroundColor = COLOR.ALERT_INFORMATIONAL_YELLOW_BG;
        style.borderColor = COLOR.ALERT_INFORMATIONAL_YELLOW_BORDER;
    }
    else if (type === ALERT_TYPE.WARNING) {
        style.backgroundColor = COLOR.ALERT_WARNING_BG;
        style.borderColor = COLOR.ALERT_WARNING_BORDER;
    }
    else if (type === ALERT_TYPE.SUCCESS) {
        style.backgroundColor = COLOR.ALERT_SUCCESS_BG;
        style.borderColor = COLOR.ALERT_SUCCESS_BORDER;
    }
    const icon = {
        [ALERT_TYPE.WARNING]: WarningIcon,
        [ALERT_TYPE.INFORMATIONAL_YELLOW]: InfoIcon,
        [ALERT_TYPE.INFORMATIONAL]: InfoIcon,
        [ALERT_TYPE.SUCCESS]: SuccessIcon,
    }[type];
    const mergedStyles = Object.assign(Object.assign({}, style), sx);
    return (_jsx(Row, Object.assign({ sx: mergedStyles }, rest, { children: _jsxs(Row, Object.assign({ sx: {
                boxSizing: 'border-box',
                margin: '0 auto',
                pl: '.5rem',
                pr: '.5rem',
                width: '100%',
            } }, { children: [icon && _jsx(Icon, { icon: icon, sx: { mr: 4 }, size: FONT_SIZE.LG }), _jsx(Row, Object.assign({ sx: { flexGrow: 1, justifyContent: 'center' } }, { children: _jsx(Markdown, { content: description }) })), _jsx(Button, Object.assign({ type: BUTTON_TYPE.TEXT, onClick: dismiss, sx: { ml: 4 } }, { children: "Dismiss" }))] })) })));
};
